/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */



export default [
  {
    path: '',
    // Relative to /src/views
    view: 'ProjectList' ,
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },

  {
    path: '/incidentTypes',
    name: 'Incident types',
    view: 'IncidentTypeList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/incidentTypeCreate',
    name: 'Create new Incident type',
    view: 'IncidentTypeCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/incidentTypeEdit/:id',
    name: 'IncidentTypeEdit',
    view: 'IncidentTypeEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },

  {
    path: '/departments',
    name: 'departments',
    view: 'DepartmentList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },

  {
    path: '/locations',
    name: 'Locations',
    view: 'LocationList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/locationCreate',
    name: 'LocationCreate',
    view: 'LocationCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/locationEdit/:id',
    name: 'LocationEdit',
    view: 'LocationEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },

  {
    path: '/measureResponsibles',
    name: 'measureResponsibles',
    view: 'MeasureResponsibleList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },

  {
    path: '/barrierOwners',
    name: 'BarrierOwners',
    view: 'BarrierOwnerList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/barrierOwnerCreate',
    name: 'BarrierOwnerCreate',
    view: 'BarrierOwnerCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/barrierOwnerEdit/:id',
    name: 'BarrierOwnerEdit',
    view: 'BarrierOwnerEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },


  {
    path: '/projectTypes',
    name: 'Project types',
    view: 'ProjectTypeList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/projectTypeCreate',
    name: 'Create new Project type',
    view: 'ProjectTypeCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/projectTypeEdit/:id',
    name: 'ProjectTypeEdit',
    view: 'ProjectTypeEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },

  {
    path: '/consequenceTypes',
    name: 'Consequence types',
    view: 'ConsequenceTypeList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/consequenceStrengths',
    name: 'Consequence strengths',
    view: 'ConsequenceStrengthList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/probabilityLevels',
    name: 'Probability levels',
    view: 'ProbabilityLevelList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/consequenceTypeCreate',
    name: 'Create new Consequence type',
    view: 'ConsequenceTypeCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/consequenceTypeEdit/:id',
    name: 'ConsequenceTypeEdit',
    view: 'ConsequenceTypeEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },



  {
    path: '/projects',
    name: 'Projects',
    view: 'ProjectList',
    requiredAuthority: 'READ'
  },
  {
    path: '/projectCreate',
    name: 'ProjectCreate',
    view: 'ProjectCreate',
    requiredAuthority: 'MANAGE_PROJECTS'
  },
  {
    path: '/projectCreateFromProject/:templateProjectId',
    name: 'ProjectCreateFromProject',
    view: 'ProjectCreate',
    requiredAuthority: 'MANAGE_PROJECTS'
  },
  {
    path: '/projectShow/:id',
    name: 'ProjectShow',
    view: 'ProjectShow',
    requiredAuthority: 'READ'
  },
  {
    path: '/projectBarrierChecklist/:id',
    name: 'ProjectBarrierChecklist',
    view: 'ProjectBarrierChecklist',
    requiredAuthority: 'READ'
  },
  {
    path: '/projectRiskAnalysis/:id',
    name: 'ProjectRiskAnalysisSummary',
    view: 'ProjectRiskAnalysisSummary',
    requiredAuthority: 'READ'
  },
  {
    path: '/barriersInOperation/:id',
    name: 'BarriersInOperation',
    view: 'BarriersInOperation',
    requiredAuthority: 'READ'
  },
  {
    path: '/projectEdit/:id',
    name: 'ProjectEdit',
    view: 'ProjectEdit',
    requiredAuthority: 'MANAGE_PROJECTS'
  },

  {
    path: '/customers',
    name: 'Customers',
    view: 'CustomerList',
    requiredAuthority: 'MANAGE_CUSTOMERS'
  },
  {
    path: '/customerCreate',
    name: 'Create new customer',
    view: 'CustomerCreate',
    requiredAuthority: 'MANAGE_CUSTOMERS'
  },
  {
    path: '/customerShow/:id',
    name: 'Customer information',
    view: 'CustomerShow',
    requiredAuthority: 'MANAGE_CUSTOMERS'
  },
  {
    path: '/customerEdit/:id',
    name: 'CustomerEdit',
    view: 'CustomerEdit',
    requiredAuthority: 'MANAGE_CUSTOMERS'
  },



  {
    path: '/potentialIncidentCreateFromTemplate/:templatePotentialIncidentId',
    name: 'PotentialIncidentCreateFromTemplate',
    view: 'PotentialIncidentCreate',
    requiredAuthority: 'MANAGE_PROJECTS'
  },

  {
    path: '/potentialIncidentCreateForProject/:projectId',
    name: 'potentialIncidentCreateForProject',
    view: 'PotentialIncidentCreate',
    requiredAuthority: 'MANAGE_PROJECTS'
  },


  {
    path: '/potentialIncidentShow/:id',
    name: 'PotentialIncident information',
    view: 'PotentialIncidentShow'
    //requiredAuthority: 'MANAGE_PROJECTS'
  },
  {
    path: '/potentialIncidentEdit/:id',
    name: 'PotentialIncidentEdit',
    view: 'PotentialIncidentEdit',
    requiredAuthority: 'MANAGE_PROJECTS'
  },

  {
    path: '/workTypes',
    name: 'Work type',
    view: 'WorkTypeList',
  requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/workTypeCreate',
    name: 'Create new work Type',
    view: 'WorkTypeCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/workTypeShow/:id',
    name: 'Work type information',
    view: 'WorkTypeShow',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/workTypeEdit/:id',
    name: 'WorkTypeEdit',
    view: 'WorkTypeEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },


  {
    path: '/workOperationCreate/:workTypeId',
    name: 'WorkOperationCreate',
    view: 'WorkOperationCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/workOperationShow/:id',
    name: 'WorkOperationShow',
    view: 'WorkOperationShow',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/workOperationEdit/:id',
    name: 'WorkOperationEdit',
    view: 'WorkOperationEdit',
    requiredAuthority: 'MANAGE_SETTINGS'
  },


  {
    path: '/login',
    name: 'Login',
    view: 'login'
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    view: 'forgotPassword'
  },
  {
    path: '/users',
    name: 'Users',
    view: 'UserList',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/userCreate',
    name: 'Create new user',
    view: 'UserCreate',
    requiredAuthority: 'MANAGE_SETTINGS'
  },
  {
    path: '/userEdit/:id',
    name: 'Edit user',
    view: 'UserEdit',
    requiredAuthority: 'MANAGE_SETTINGS'

  },
  {
    path: '/MyProfileEdit',
    name: 'MyProfileEdit',
    view: 'MyProfileEdit'
  },
  {
    path: '/logout',
    name: 'Logout',
    view: 'logout'
  }

]
